import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrganizationEmployeeStoreState } from "../types/organizationEmployee";
import { SearchDefaultValue, SearchValue } from "./types";

const initialState: OrganizationEmployeeStoreState = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const employee = createSlice({
  name: "employee",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = employee.actions;

export const selectSearchValue = (state: {
  employee: OrganizationEmployeeStoreState;
}) => state?.employee?.searchValue;
export const selectIsActive = (state: {
  employee: OrganizationEmployeeStoreState;
}) => state?.employee?.isActive;

export default employee.reducer;
